package org.vreo.devicehub.features.device.data.dto.control

import kotlinx.serialization.Serializable

/**
 * Local device message dto, used for receiving messages from device on local network.
 *
 * @property payload message payload
 */
@Serializable
data class LocalDeviceMessageDto(
    val payload: String
)
